module.exports = __webpack_public_path__ + "media/andenes/desnivel_guide-0fc90ea2.webp";